const parseBlockedEmailsConfig = (configStr = "") => {
  const config = {};
  const featurePairs = configStr.split(";");

  featurePairs.forEach((pair) => {
    const [feature, emails] = pair.split(":");
    if (feature && emails) {
      config[feature] = emails.split(",").map((email) => email.trim());
    }
  });

  return config;
};

export const BLOCKED_FEATURES = {
  ALL: "all",

  DASHBOARD: {
    ALLOCATED_TABLE: "dashboardAllocatedTable",
  },

  CARDS: {
    PAGE_HEADER_ACTIONS: "cardsPageHeaderActions",
    TEAM_BALANCE: "cardsTeamBalance",
    TRANSPORTER_PAYMENTS: "cardsTransporterPayments",
    REQUEST_PREFUND: "cardsRequestPrefund",
    TRANSFER_FUND: "cardsTransferFund",
  },

  BULK_OPERATIONS: {
    PAGE: "bulkOperationPage",
  },

  REQUEST: {
    PAGE: "requestPage",
  },

  SETTINGS: {
    USERS: {
      ADD_USER: "settingsUsersAddUser",
      ALL_ACTIONS: "settingsUsersAllAction",
    },
  },

  WPS: {
    PAGE: "wps",
  },
};

const blockedEmailsConfigStr =
  process.env.REACT_APP_BLOCKED_EMAILS_CONFIG || "";
const blockedEmailsConfig = parseBlockedEmailsConfig(blockedEmailsConfigStr);

export const isEmailBlockedForFeature = (featureKey, userEmail) => {
  const blockedEmails = blockedEmailsConfig[featureKey] || [];
  return blockedEmails.includes(userEmail);
};
